import axios, { type AxiosInstance } from 'axios';
import { useAuthStore } from '@/stores/authStore';

/**
 * Root-mounted axios instance (epics 200/201/202).
 *
 * The OAuth 2.0 authorization-code flow (`/oauth/*`) and the inbound-webhook
 * actions metadata (`/webhooks/in/_meta/actions`) are mounted at the server
 * ROOT — not under `/api/v1` — so the shared `apiClient` (baseURL `/api/v1`)
 * cannot reach them. This thin instance targets `/` while still attaching the
 * Bearer access token from the auth store so consent screens work while
 * logged in. It deliberately has no refresh/retry chain: these calls live in
 * the standalone consent flow where a 401 simply bounces back to /login.
 */
export const rootClient: AxiosInstance = axios.create({
  baseURL: '/',
  headers: { 'Content-Type': 'application/json' },
});

rootClient.interceptors.request.use((config) => {
  const token = useAuthStore.getState().tokens?.accessToken;
  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  return config;
});
